<template>
  <div>
    <ProgressBar />
    <PageHeading :default-heading="pageHeader" />
    <form
      ref="nurForm"
      :action="pd_envConfig.nurURL"
      method="POST"
      @submit.prevent
    >
      <div
        v-if="rc_accountNumber && rc_accountStatus !== 'FAILURE'"
        id="igoFinalPage"
        class="pvd-container container-divider"
      >
        <h2
          id="igoHeading"
          class="pvd-heading-L"
        >
          {{ `${pd_content.your_accountnumber} ${rc_accountNumber}` }}
        </h2>
        <p
          id="igofirstlede"
        >
          {{ pd_content.pin_setup_description }}
        </p>

        <!-- NUR hidden form fields -->
        <input
          ref="ssn"
          type="hidden"
          name="ssn"
          value=""
        >
        <input
          ref="dob"
          type="hidden"
          name="dob"
          value=""
        >
        <input
          ref="zip"
          type="hidden"
          name="zip"
          value=""
        >
        <input
          ref="account"
          type="hidden"
          name="account"
          value=""
        >
        <input
          type="hidden"
          name="redirectURL"
          :value="authRedirectUrl"
        >
      </div>
      <div
        v-else
        id="nigoFinalPage"
        class="pvd-container container-divider"
      >
        <h2
          id="nigoHeading"
          class="pvd-heading-L"
        >
          {{ pd_content.customer_nigo_first_lede }}
        </h2>
        <p
          id="nigoFirstlede"
        >
          {{ pd_content.customer_nigo_second_lede }}
        </p>
        <p
          v-if="isManagedAccount"
          id="nigoPreventDuplicateAcct"
        >
          {{ pd_content.customer_prevent_duplicate_open_account }}
        </p>
        <p
          id="nigoSecondlede"
        >
          {{ pd_content.customer_nigo_third_lede }}
        </p>
        <p>
          <a
            id="fidLink"
            :href="pd_content.customer_nigo_link.url"
            @click="handleNIGOLinkClick"
          >
            {{ pd_content.customer_nigo_link.value }}
          </a>
        </p>
      </div>
      <NavigationComponent
        :show-primary-action="showNext"
      />
    </form>
  </div>
</template>

<script>
import dataHelper from '../mixins/dataHelper';
import NavigationComponent from '../components/NavigationComponent.vue';
import PageHeading from '../components/PageHeading.vue';
import ProgressBar from '../components/ProgressBar.vue';
import measurement from '../mixins/measurement';
import utility from '../mixins/utility';

export default {
  name: 'FinalPage',
  components: {
    NavigationComponent,
    PageHeading,
    ProgressBar,
  },
  mixins: [dataHelper, measurement, utility],
  data() {
    return {
      backButtonAttempt: false,
    };
  },
  computed: {
    isManagedAccount() {
      return this.isManaged(this.routeId);
    },
    authRedirectUrl() {
      const queryParameters = `NEW_CUSTOMER=true&ACCOUNT_NO=${this.rc_accountNumber}#/customer-igo`;
      return `${document.location.origin}${document.location.pathname}?${queryParameters}`;
    },
    pageHeader() {
      let header;
      if (this.rc_accountNumber && this.rc_accountStatus !== 'FAILURE') {
        header = this.pd_content.final_page_header;
      } else {
        header = this.pd_content.customer_nigo_page_header;
      }
      if (header) {
        document.title = this.setTitle(header);
      }

      return header;
    },
    showNext() {
      return this.rc_accountNumber && this.rc_accountStatus !== 'FAILURE' ? 'Yes' : 'No';
    },
  },
  mounted() {
    if (localStorage.getItem('contextKey')) {
      localStorage.removeItem('contextKey');
    }
    if (localStorage.getItem('transactionContextKey')) {
      localStorage.removeItem('transactionContextKey');
    }
    this.configureBackButtonFunctionality(() => this.showBackWarning(
      this.pd_content.back_button_disabled_warning,
    ));
    this.track(this.cs_stateName, 'pageview');
  },
  methods: {
    handleNIGOLinkClick() {
      window.location.assign(this.pd_envConfig.nigoFidURL);
    },
  },
};
</script>

<style scoped>

</style>
